import { useLocation } from "react-router-dom"
import qs from "qs"

const UseQuery = (): Record<string, any> => {
  const { search } = useLocation()
  return qs.parse(search.replace("?", ""))
}

export default UseQuery
